import { Table, TableColumns } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

type AbsenceEvaluationMemberOverviewTableType = {
  name: string;
  from: string;
  until: string;
  comment: string;
  reason: string;
  excused: boolean;
};

export const AbsenceEvaluationMemberOverviewTable = () => {
  const { t } = useTranslation();

  const columns: TableColumns<AbsenceEvaluationMemberOverviewTableType>[] = [
    {
      id: 'name',
      accessorKey: 'name',
      header: t('common.name'),
      size: 225,
    },
    {
      id: 'from',
      accessorKey: 'from',
      header: t('common.from'),
      size: 150,
    },
    {
      id: 'until',
      accessorKey: 'until',
      header: t('common.until'),
      size: 150,
    },
    {
      id: 'comment',
      accessorKey: 'comment',
      header: t('common.comment'),
      size: 250,
    },
    {
      id: 'reason',
      accessorKey: 'reason',
      header: t('absences.reasons.title', { context: 'short' }),
      size: 175,
    },
    {
      id: 'isExcused',
      accessorKey: 'isExcused',
      header: t('absences.isExcused'),
      type: 'boolean',
      size: 75,
    },
  ];

  const data: AbsenceEvaluationMemberOverviewTableType[] = [];

  return (
    <Table<AbsenceEvaluationMemberOverviewTableType>
      columns={columns}
      data={data}
      showBorderRadius
      showShadow
      emptyStateSettings={{ subtitle: '' }}
    />
  );
};
